import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Textarea } from "@/shared/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/select";
import { LearningContent, MediaProvider } from "@/features/learnings/service/learningService";
import { VideoPreview } from "./VideoPreview";
import { useEffect } from "react";

interface Props {
    index: number;
    value: LearningContent;
    onChange: (index: number, field: keyof LearningContent, value: any) => void;
    validationError?: string;
    clearFieldError?: (field: string) => void;
}

export const VideoContentInput: React.FC<Props> = ({
    index,
    value,
    onChange,
    validationError,
    clearFieldError
}) => {
    useEffect(() => {
        // Inicializa valores padrão se não existirem
        if (!value.title) {
            onChange(index, 'title', '');
        }
        if (!value.description) {
            onChange(index, 'description', '');
        }
        if (!value.provider) {
            onChange(index, 'provider', 'YOUTUBE' as MediaProvider);
        }
    }, [index, onChange, value.title, value.description, value.provider]);

    const handleFieldChange = (field: keyof LearningContent, newValue: any) => {
        onChange(index, field, newValue);
        clearFieldError?.(`contents.${index}.${field}`);
    };

    return (
        <div className="space-y-4">
            <div>
                <Label htmlFor={`video-title-${index}`} className="text-white">
                    Título do Vídeo *
                </Label>
                <Input
                    id={`video-title-${index}`}
                    value={value.title || ''}
                    onChange={(e) => handleFieldChange('title', e.target.value)}
                    placeholder="Digite o título do vídeo"
                    className="bg-[#222222] border-[#333333] text-white placeholder:text-gray-400"
                />
            </div>

            <div>
                <Label htmlFor={`video-description-${index}`} className="text-white">
                    Descrição
                </Label>
                <Textarea
                    id={`video-description-${index}`}
                    value={value.description || ''}
                    onChange={(e) => handleFieldChange('description', e.target.value)}
                    placeholder="Digite uma descrição para o vídeo"
                    className="bg-[#222222] border-[#333333] text-white placeholder:text-gray-400"
                    rows={3}
                />
            </div>

            <div>
                <Label htmlFor={`video-provider-${index}`} className="text-white">
                    Provedor *
                </Label>
                <Select
                    value={value.provider || 'YOUTUBE'}
                    onValueChange={(newValue) => handleFieldChange('provider', newValue as MediaProvider)}
                >
                    <SelectTrigger className="bg-[#222222] border-[#333333] text-white">
                        <SelectValue placeholder="Selecione o provedor" />
                    </SelectTrigger>
                    <SelectContent className="bg-[#222222] border-[#333333]">
                        <SelectItem value="YOUTUBE" className="text-white hover:bg-[#333333]">
                            YouTube
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <VideoPreview
                value={value.value}
                onChange={(newValue) => handleFieldChange('value', newValue)}
                validationError={validationError}
                clearFieldError={clearFieldError}
            />
        </div>
    );
};
